import FieldDefs from './AdConcurentsFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import {Listeners} from "../../constants/listeners";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.adconcurents.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'cnt',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            viewMode: 1,
            options: [
                {label: this.$t('lang.report.adconcurents.organic'), value: 0},
                {label: this.$t('lang.report.adconcurents.context'), value: 1},
            ],
        }
    },
    mounted () {
        this.initFields();
    },
    computed: {
        self() {
            return this;
        },
    },
    methods: {
        initFields () {
            let self = this;
            self.fields.forEach((f) =>{
                if(f.hasOwnProperty('visibleRule')){
                    f.visible = eval(f.visibleRule);
                }
            });
            this.$emitter.emit(Listeners.KS_TABLE_NORMALIZE_FIELDS);
        }
    },
    watch: {
        viewMode: function(val){
            this.initFields();
        }
    }

}
